import { useState } from "react";
import { addMarketingPromotionsForm } from "../../lib/actions";
import { useNavigate } from "react-router-dom";
import { FiUploadCloud, FiInfo } from "react-icons/fi";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { useTranslation } from "react-i18next";
import DropDownMultiSelect from "../../components/GDropDownList/DropDownMultiSelect";

// تحديث دليل القياسات ليشمل مقاسات الموقع والموبايل
const AD_SIZES = [
    { 
        id: "home",
        label_en: "Home Page Banner", 
        label_ar: "بانر الرئيسية", 
        web: " Full Width x 240px",
        mobile: " Full Width x 160px" // المقاس الجديد للموبايل
    },
    { 
        id: "search",
        label_en: "Search Page", 
        label_ar: "صفحة البحث", 
        web: " 320px x 214px",
        mobile: " Full Width x 160px" // بناءً على البيانات السابقة
    },
    { 
        id: "details",
        label_en: "Ad Details / My Ads / Liked", 
        label_ar: "تفاصيل الإعلان / إعلاناتي", 
        web: " 320px x 214px",
        mobile: " Full Width x 160px"
    },
    { 
        id: "profile",
        label_en: "User Profile", 
        label_ar: "الملف الشخصي", 
        web: " 304px x 202px",
        mobile: " Full Width x 160px"
    },
];

export default function AddMarketingPromotionsUi({ devices, marketingPromotionPosition }) {

    const nav = useNavigate();
    const [selectedValues, setSelectedValues] = useState({ positionsId: null, devicesId: null });
    const [image, setImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const { i18n } = useTranslation();
    const t = i18n.t.bind(i18n);
    const currentLang = i18n.language;

    const onChange = (e, paramkey) => {
        setSelectedValues(prev => ({
            ...prev,
            [paramkey]: e
        }));
    };

    const handleSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();
        const formData = new FormData(e.target);
        const result = await addMarketingPromotionsForm(formData, navigate);
        setLoading(false);
    };

    const navigate = (route) => {
        nav(route);
    };

    const handleImageChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            setImage(URL.createObjectURL(file));
        }
    };

    const handleDeleteImage = () => {
        setImage(null);
    };

    return (
        <form onSubmit={handleSubmit} className="w-full">
            <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 pb-6">
                
                <div className="w-full">
                    <label className="block text-white mb-2"> {currentLang === "en" ? "Link" : "الرابط"} </label>
                    <input
                        type="text"
                        name="link"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg focus:outline-none focus:border-secondary"
                        required
                        placeholder={currentLang === "en" ? "Enter link" : "أدخل الرابط"}
                    />
                </div>

                <div className="w-full">
                    <label className="block text-white mb-2"> {currentLang === "en" ? "Start Time" : "وقت البداية"} </label>
                    <input
                        type="date"
                        name="start_time"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg focus:outline-none focus:border-secondary"
                        required
                    />
                </div>

                <div className="w-full">
                    <label className="block text-white mb-2"> {currentLang === "en" ? "End Time" : "وقت الإنتهاء"} </label>
                    <input
                        type="date"
                        name="end_time"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg focus:outline-none focus:border-secondary"
                        required
                    />
                </div>

                <div className="w-full">
                    <label className="block text-white mb-2"> {currentLang === "en" ? "Position" : "المكان"} </label>
                    <DropDownMultiSelect 
                        options={marketingPromotionPosition} 
                        value={selectedValues.positionsId} 
                        onchange={(e) => onChange(e, "positionsId")} 
                        defaultText={currentLang === "en" ? "Choose position" : "إختر مكان الظهور"} 
                        paramkey={"positions[]"} 
                    />
                </div>

                <div className="w-full">
                    <label className="block text-white mb-2"> {currentLang === "en" ? "Devices" : "الأجهزة"} </label>
                    <DropDownMultiSelect 
                        options={devices} 
                        value={selectedValues.devicesId} 
                        onchange={(e) => onChange(e, "devicesId")} 
                        defaultText={currentLang === "en" ? "Choose devices" : "إختر الأجهزة"} 
                        paramkey={"devices[]"} 
                    />
                </div>
            </div>

            {/* تم تحديث تصميم جدول القياسات ليعرض الويب والموبايل بشكل أوضح */}
            <div className="mb-6 bg-blue-500/10 border border-blue-500/30 rounded-xl p-4">
                <div className="flex items-center gap-2 mb-3 text-blue-200">
                    <FiInfo className="text-xl" />
                    <span className="font-bold">{currentLang === "en" ? "Size Guide (Width x Height):" : "دليل القياسات (العرض × الارتفاع):"}</span>
                </div>
                {/* Grid متجاوب يعرض البطاقات */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                    {AD_SIZES.map((item, index) => (
                        <div key={index} className="bg-thirdly/60 p-3 rounded-lg border border-white/5 flex flex-col justify-between h-full">
                            <span className="font-bold text-white mb-2 text-sm border-b border-white/10 pb-2">
                                {currentLang === "en" ? item.label_en : item.label_ar}
                            </span>
                            <div className="text-xs text-gray-300 space-y-1">
                                <div className="flex justify-between">
                                    <span className="text-gray-400">Web:</span>
                                    <span dir="ltr" className="text-secondary font-mono">{item.web}</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-gray-400">Mobile:</span>
                                    <span dir="ltr" className="text-orange-400 font-mono">{item.mobile}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="mb-8 w-full">
                <label className="block text-white mb-3 font-medium">{currentLang === "en" ? "Promotion Photo" : "صورة الإعلان"}</label>
                
                <div className="w-full bg-thirdly p-6 rounded-2xl border-2 border-dashed border-gray-200 hover:border-secondary transition-colors">
                    <div className="relative group w-full">
                        <div className={`flex flex-col items-center justify-center h-64 w-full ${!image ? 'bg-furthly' : 'bg-transparent'} rounded-xl transition-all`}>
                            {!image ? (
                                <>
                                    <FiUploadCloud className="w-14 h-14 text-white mb-3 group-hover:text-secondary transition-colors" />
                                    <span className="text-base text-white group-hover:text-secondary transition-colors">
                                        {currentLang === "en" ? "Click to upload a photo" : "انقر لرفع الصورة"}
                                    </span>
                                </>
                            ) : (
                                <div className="relative w-full h-full">
                                    <img src={image} alt="Promotion" className="w-full h-full object-contain rounded-xl" />
                                    <button type="button" className="absolute top-2 left-2 z-50 bg-red-500 text-white p-2 rounded-full hover:bg-red-600 transition-colors shadow-lg" onClick={handleDeleteImage}>
                                        <MdOutlineDeleteOutline className="w-5 h-5" />
                                    </button>
                                </div>
                            )}
                        </div>
                        <input type="file" name="promotion" accept="image/*" className="absolute inset-0 w-full h-full opacity-0 cursor-pointer" onChange={handleImageChange} required />
                    </div>
                </div>
            </div>

            <div className="flex justify-center w-full mt-5">
                <button type="submit" disabled={loading} className={`w-full sm:w-2/5 md:w-[20%] bg-secondary text-white py-2.5 rounded-lg transition flex items-center justify-center font-medium shadow-lg hover:shadow-secondary/50 ${loading ? "cursor-not-allowed opacity-70" : "hover:bg-primary" }`} >
                    {loading ? (
                        <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" ></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                        </svg>
                    ) : 
                        t("button.save")
                    }
                </button>
            </div>
        </form>
    );
};